import { inject as service } from '@ember/service';
import Route from 'cio/routes/base';
import StripeV3Service from 'ember-stripe-elements/services/stripev3';

export default class CheckoutRoute extends Route {
  @service('stripev3') stripe!: StripeV3Service;

  crumb() {
    return {
      name: 'Checkout',
      path: this.routeName,
    };
  }

  redirect() {
    this.router.transitionTo('settings.billing.checkout');
  }
}
